/**
 * Represents a book.
 * @constructor
 * @param {String} containerId - The id of the Legend Container.
 */
const getOrCreateLegendList = (containerId) => {
  const legendContainer = document.getElementById(containerId);
  let listContainer = legendContainer.querySelector('ul');

  if (!listContainer) {
    listContainer = document.createElement('ul');
    listContainer.style.display = 'flex';
    listContainer.style.flexDirection = 'row';
    listContainer.style.margin = 0;
    listContainer.style.padding = 0;

    legendContainer.appendChild(listContainer);
  }

  return listContainer;
};

/**
 * Represents a Custom HTML Legend.
 * @param {Chart} chart - The Chart from Chart JS.
 */
export const htmlLegendPlugin = {
  id: 'htmlLegend',
  afterUpdate(chart, args, options) {
    const ul = getOrCreateLegendList(options.containerID);

    // Remove old legend items
    while (ul.firstChild) {
      ul.firstChild.remove();
    }

    // Reuse the built-in legendItems generator
    const items = chart.options.plugins.legend.labels.generateLabels(chart);

    items.forEach((item) => {
      const li = document.createElement('li');
      li.style.alignItems = 'center';
      li.style.cursor = 'pointer';
      li.style.display = 'flex';
      li.style.flexDirection = 'row';
      li.style.marginLeft = '10px';

      li.onclick = () => {
        const { type } = chart.config;
        if (type === 'pie' || type === 'doughnut') {
          // Pie and doughnut charts only have a single dataset and visibility is per item
          chart.toggleDataVisibility(item.index);
        } else {
          chart.setDatasetVisibility(item.datasetIndex, !chart.isDatasetVisible(item.datasetIndex));
        }
        chart.update();
      };

      // Color box
      const boxSpan = document.createElement('span');
      boxSpan.style.background = item.fillStyle;
      boxSpan.style.borderColor =
        item.strokeStyle !== 'rgba(0,0,0,0.1)' ? item.strokeStyle : item.fillStyle;
      boxSpan.style.borderWidth = '1px';
      boxSpan.style.display = 'inline-block';
      boxSpan.style.flexShrink = 0;
      boxSpan.style.marginRight = '10px';
      boxSpan.style.borderRadius = '5px';
      boxSpan.style.minWidth = '52px';
      boxSpan.style.display = 'flex';
      boxSpan.style.justifyContent = 'center';
      boxSpan.style.borderStyle = 'solid';

      // Text
      const textContainer = document.createElement('p');
      textContainer.style.textDecoration = item.hidden ? 'line-through' : '';
      textContainer.style.margin = '0';
      textContainer.style.padding = '3px';
      textContainer.style.color = '#4a566b';

      const text = document.createTextNode(item.text);
      textContainer.appendChild(text);

      li.appendChild(boxSpan);
      boxSpan.appendChild(textContainer);
      ul.appendChild(li);
    });
  },
};
